// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"cd579e7c7084b0b12ecb","655":"3853545a0d8d933de85a"}[chunkId] + ".js";
};